import Demographics from "./demographics";
import AdministratorDetails from "./administratorDetails";
import CollegePrep from "./collegePrep";
import Documents from "./documents";
import Notes from "./AdministrativeNotes/notes";
// import History from "./History/history"; // has503 — History section hidden on Scholars for now
import HighSchool from "./highschool";
import Rubric from "./rubric";
import ScholarsRatingsReadOnly from "./ScholarsRatingsReadOnly";
import ScholarsPreferences from "./ScholarsPreferences";
import ScholarsRecommendation from "./ScholarsRecommendation";
import { AUTH_ROLES_CHECK } from "../../util/constants";

/**
 * has507 — Scholars-specific sections for the applicant details page.
 * Separated from the shared Honors sections to prevent regressions and allow
 * scholars-tailored content without conditional hacks.
 *
 * Included natively (no conditional needed):
 * - Scholars Preferences (view + edit)
 * - Ratings (reviewer scoring tool; user-facing label for the "rubric" feature).
 *   Uses the same shared Rubric component as Honors; the getScholarsApplicationDetails
 *   query already returns configuration.rubric + resumeLaterRubricValues, so no backend
 *   change is required. Shown only to the current reviewer (same rule as Honors).
 *
 * Excluded from Honors version:
 * - Recommendation (honors workflow-specific submit) — Scholars uses "Review and Decision"
 */
const scholarsSections = [
    // has503 — Recommendation History hidden on the Scholars applicant details page for now.
    // Scholars uses a single-read decision model surfaced in "Review and Decision".
    // {
    //     id: "history",
    //     Component: History,
    //     heading: "History",
    //     sortPriority: 10,
    //     customFilter: (filterFlags) => filterFlags.isAdmin,
    //     authorization: [AUTH_ROLES_CHECK.IS_SCHOLARS_ADMIN, AUTH_ROLES_CHECK.IS_SCHOLARS_PROGRAM_MANAGER, AUTH_ROLES_CHECK.IS_SCHOLARS_REVIEWER],
    // },
    {
        id: "scholarsPreferences",
        Component: ScholarsPreferences,
        heading: "History",
        sortPriority: 15,
        authorization: [AUTH_ROLES_CHECK.IS_SCHOLARS_ADMIN],
    },
    {
        id: "demographics",
        Component: Demographics,
        heading: "Demographics",
        sortPriority: 20,
        authorization: [AUTH_ROLES_CHECK.IS_SCHOLARS_ADMIN, AUTH_ROLES_CHECK.IS_SCHOLARS_PROGRAM_MANAGER, AUTH_ROLES_CHECK.IS_SCHOLARS_REVIEWER],
    },
    {
        id: "administratorDetails",
        Component: AdministratorDetails,
        heading: "Administrator Details",
        sortPriority: 25,
        authorization: [AUTH_ROLES_CHECK.IS_SCHOLARS_ADMIN],
    },
    {
        id: "highschool",
        Component: HighSchool,
        heading: "High School",
        sortPriority: 30,
        authorization: [AUTH_ROLES_CHECK.IS_SCHOLARS_ADMIN, AUTH_ROLES_CHECK.IS_SCHOLARS_PROGRAM_MANAGER, AUTH_ROLES_CHECK.IS_SCHOLARS_REVIEWER],
    },
    {
        id: "collegePrep",
        Component: CollegePrep,
        heading: "College Prep Units",
        sortPriority: 40,
        authorization: [AUTH_ROLES_CHECK.IS_SCHOLARS_ADMIN, AUTH_ROLES_CHECK.IS_SCHOLARS_PROGRAM_MANAGER, AUTH_ROLES_CHECK.IS_SCHOLARS_REVIEWER],
    },
    {
        id: "documents",
        Component: Documents,
        heading: "Documents",
        sortPriority: 80,
        authorization: [AUTH_ROLES_CHECK.IS_SCHOLARS_ADMIN, AUTH_ROLES_CHECK.IS_SCHOLARS_PROGRAM_MANAGER, AUTH_ROLES_CHECK.IS_SCHOLARS_REVIEWER],
    },
    {
        id: "rubric",
        Component: Rubric,
        heading: "Ratings",
        sortPriority: 90,
        // Scholars is queue-based: show Ratings while the applicant is actively in review in a program
        // queue (IN_REVIEW), not gated on a per-person reviewer assignment (which Scholars doesn't use).
        customFilter: (filterFlags) => filterFlags.isInReview,
        authorization: [AUTH_ROLES_CHECK.IS_SCHOLARS_ADMIN, AUTH_ROLES_CHECK.IS_SCHOLARS_PROGRAM_MANAGER, AUTH_ROLES_CHECK.IS_SCHOLARS_REVIEWER],
    },
    {
        // Read-only Ratings once a recommendation has been submitted (entry RECOMMENDED). Gives admins/PMs
        // parity with Honors' post-submission ratings visibility, without re-introducing the History section
        // (has503 kept it hidden on Scholars). Mutually exclusive with the editable section above
        // (IN_REVIEW vs RECOMMENDED), so only one renders at a time.
        id: "rubricReadOnly",
        Component: ScholarsRatingsReadOnly,
        heading: "Ratings",
        sortPriority: 90,
        customFilter: (filterFlags) => filterFlags.isRecommended,
        authorization: [AUTH_ROLES_CHECK.IS_SCHOLARS_ADMIN, AUTH_ROLES_CHECK.IS_SCHOLARS_PROGRAM_MANAGER, AUTH_ROLES_CHECK.IS_SCHOLARS_REVIEWER],
    },
    {
        id: "otherNotes",
        Component: Notes,
        heading: "Administrative Notes",
        sortPriority: 100,
        authorization: [AUTH_ROLES_CHECK.IS_SCHOLARS_ADMIN, AUTH_ROLES_CHECK.IS_SCHOLARS_PROGRAM_MANAGER, AUTH_ROLES_CHECK.IS_SCHOLARS_REVIEWER],
    },
    {
        id: "scholarsRecommendation",
        Component: ScholarsRecommendation,
        heading: "Review and Decision",
        sortPriority: 110,
        authorization: [AUTH_ROLES_CHECK.IS_SCHOLARS_ADMIN, AUTH_ROLES_CHECK.IS_SCHOLARS_PROGRAM_MANAGER, AUTH_ROLES_CHECK.IS_SCHOLARS_REVIEWER],
    },
];

export default scholarsSections;
